export const REMEMBER='remember_me'
export const CONGRESS='congress'
export const XTenantID='X-Tenant-ID'
export const USERINFO='user_info'
export const REDIRECTURI='redirect_uri'
export const CLIENT_ID='client_id'
export const I18N_COOKIE_KEY = 'i18n_redirect'
export const FINGERPRINT='fingerprint'
